export const ngOnload = () => {
  return {
    restrict: 'A',
    scope: {
      callback: '&ngOnload'
    },
    link: (scope, element) => {
      // hooking up the onload event - calling the callback on load event
      element.on('load', () => {
        const contentLocation = element.length > 0 && element[0].contentWindow
          ? element[0].contentWindow.location
          : undefined;

        scope.callback({ contentLocation });
      });
    }
  };
};
